import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * The nodes a note points to, by `stableStepId` (resolves against both draft
 * steps and live recordings). Empty = a free, process-wide comment; non-empty =
 * the note annotates each of those nodes, drawn as connector lines. A target
 * whose node no longer exists is ignored at render and pruned on node deletion.
 */ export const NoteTargetsSchema = z.array(ObjectIdSchema);

//# sourceMappingURL=note-targets.schema.js.map